module.exports = __webpack_public_path__ + "images/f0701366596414ac10dfcf2b21905136.png";